import React from 'react'
import { AcompanhamentoCard } from 'view/atendimentos/detail/acompanhamentos/components/AcompanhamentoCard'

import { ProntuarioCard } from '../ProntuarioCard'
import { AcompanhamentoVulnerabilidadeCard } from './AcompanhamentoVulnerabilidadeCard'

interface AcompanhamentoVulnerabilidadeContentProps {
  isAcompanhamentoPreNatal: boolean
  loading: boolean
  showAcompanhamentoVulnerabilidade: boolean
  isBeneficiarioBolsaFamilia: boolean
  dataRegistro: LocalDate
}

export const AcompanhamentoVulnerabilidadeContent = (props: AcompanhamentoVulnerabilidadeContentProps) => {
  const {
    isAcompanhamentoPreNatal,
    loading,
    showAcompanhamentoVulnerabilidade,
    isBeneficiarioBolsaFamilia,
    dataRegistro,
  } = props

  const renderVulnerabilidadeCard = () => (
    <AcompanhamentoVulnerabilidadeCard
      dataRegistro={dataRegistro}
      isBeneficiarioBolsaFamilia={isBeneficiarioBolsaFamilia}
    />
  )

  if (isAcompanhamentoPreNatal) {
    return (
      <AcompanhamentoCard
        id='acompanhamento-vulnerabilidade'
        title='Acompanhamento de vulnerabilidade'
        loading={loading}
        placeholder='Nenhuma vulnerabilidade registrada'
      >
        {showAcompanhamentoVulnerabilidade && renderVulnerabilidadeCard()}
      </AcompanhamentoCard>
    )
  } else if (showAcompanhamentoVulnerabilidade) {
    return <ProntuarioCard title='Acompanhamento de vulnerabilidade'>{renderVulnerabilidadeCard()}</ProntuarioCard>
  } else {
    return null
  }
}
